/*jshint esversion: 8 */
/* eslint-disable */
// f**k decorator
/** MobX */
import { observable, decorate } from 'mobx';

class Store {
  // 全局方法
  search = function () { };

  // 市场id
  marketId = '9999';
  setMarketId(id) {
    this.marketId = id;
  }
  clearMarketId() {
    this.marketId = '';
  }

  iniPage() {
    this.clearSelection();
    this.clearTableConfig();
    this.clearTableCols();
    this.clearTable();
  }

  // 用户信息
  user = {
    logined: false,
    marketId: '',
    JWTToken: '',
    name: '',
    uuid: '',
    memname: '',
    rolename: '',
    phone: '',
    authSettings: {},
  };

  userSignin(data) {
    this.user = {
      logined: true,
      marketId: data.marketId || '',
      JWTToken: data.token || '',
      name: data.name || '',
      uuid:  data.uuid || '',
      memname: data.memname || '',
      rolename: data.rolename || '',
      phone: data.phone || '',
      authSettings: data.authSettings || {},
    };
  }

  userExist() {
    this.user = {
      logined: false,
      JWTToken: '',
      name: '',
      uuid: '',
      memname: '',
      phone: '',
      rolename: '',
      authSettings: {},
    };
  }

  // 表选项
  selections = {};
  setSelections(s) {
    this.selections = s;
  };

  clearSelection() {
    this.selections = {};
  }

  onChangeSelection(e, field) {
    e.stopPropagation();
    this.selections[field] = e.target.value;
  }

  // 选中的行
  linesSelected = [];
  setLinesSelected(s) {
    this.linesSelected = s;
  }
  clearLinesSelected() {
    this.linesSelected = [];
  }

  // 表信息
  tableConfig = {
    order: '', // 排序方式
    orderBy: '',
    currentPage: 0, // 当前页
    rowsPerPage: 10, // 每页条数
  };
  setOrderOfTableConfig(o) {
    this.tableConfig.order = o;
  }
  setOrderByOfTableConfig(o) {
    this.tableConfig.orderBy = o;
  }
  setRowsPerPageOfTableConfig(r) {
    this.tableConfig.rowsPerPage = r;
  }
  setCurrentPageOfTableConfig(p) {
    this.tableConfig.currentPage = p;
  }
  clearTableConfig() {
    this.tableConfig = {
      order: '',
      orderBy: '', // 排序方式
      currentPage: 0, // 当前页
      rowsPerPage: 10, // 每页条数
    };
  }


  // 表列，用于选择需要显示的列
  tableCols = [];
  setTableCols(c) {
    this.tableCols = tableCols;
  }
  clearTableCols(c) {
    this.tableCols = [];
  }

  // 提示信息
  msg = {
    msgKey: 0,
    msgType: 'info',
    msgTxt: 'MobX test',
  };
  showMsg(msgTxt, msgType) {
    const { msgKey: oldKey } = this.msg;
    this.msg = {
      msgTxt,
      msgType,
      msgKey: oldKey + 1,
    };
  }

  table = [];
  setTable(t) {
    this.table = t;
  };
  clearTable() {
    this.table = [];
  }

  tableCount = 0;
  setTableCount(c) {
    this.tableCount = c;
  };
  clearTableCount() {
    this.tableCount = 0;
  }

  developerTable = [];
  setDeveloperTable(t) {
    this.developerTable = t;
  };
  clearDeveloperTable() {
    this.developerTable = [];
  }



  roleTable = [];
  setRoleTable(t) {
    this.roleTable = t;
  };
  clearRoleTable() {
    this.roleTable = [];
  }

  // 提示弹出框
  messageDialogInfo = {
    open: false,
    dialogMsg: '',
  };
  closeMessageDialogOpen() {
    this.messageDialogInfo = {
      open: false,
      dialogMsg: '',
    };
  }
  openMessageDialogOpen(msg) {
    this.messageDialogInfo = {
      open: true,
      dialogMsg: msg,
    };
  }
}

decorate(Store, {
  leftDrawerOpen: observable,
  user: observable,
  msg: observable,
  marketId: observable,
  selections: observable,
  tableConfig: observable,
  tableCols: observable,
  authMap: observable,
  table: observable,
  developerTable: observable,
  roleTable: observable,
  linesSelected: observable,
  tableCount: observable,
  messageDialogInfo: observable,
});

var store = window.store = new Store;
export default store;
